import { MessageCircle } from "lucide-react";

const WHATSAPP_NUMBER = "56999176009";
const WHATSAPP_MESSAGE = "Hola Carlos, me gustaría conversar sobre EOS para mi empresa.";
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;

export default function WhatsAppFloat() {
  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Contactar por WhatsApp"
      data-testid="whatsapp-float-button"
      className="fixed z-40 bottom-6 right-6 group flex items-center gap-3 bg-[#25D366] text-white pl-5 pr-6 py-4 rounded-full shadow-lg hover:shadow-xl hover:-translate-y-0.5 transition-all duration-200"
    >
      <span className="relative flex w-6 h-6 items-center justify-center">
        <span className="absolute inline-flex w-full h-full rounded-full bg-white opacity-25 animate-ping" />
        <MessageCircle className="w-6 h-6 relative" strokeWidth={2} />
      </span>
      <span className="text-base font-semibold">Conversemos</span>
    </a>
  );
}
